// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609291604/js/" + chunkId + "." + {"44":"ce42893f","225":"d3832f8c","481":"57ec358c","486":"d2eb7f1e","770":"bbe5b173"}[chunkId] + ".0.9301087266070801.chunk.js";
};